import { PremiumFeature } from 'gleblu-socket-api';
import { createSelector } from 'reselect';

import { getPriceKey, getSubscriptionKey } from '../../utils/subscriptions';
import { Store } from '../reducers/reducers';

const fetchStateSelector = (store: Store) => store.fetchState;

export const authenticationPostStateSelector = createSelector(fetchStateSelector, (fetchState) => fetchState.authenticationTokenFetchState);

export const placeLocalizationByPlaceUuidFetchStateSelector = (placeUuid: string) =>
  createSelector(fetchStateSelector, (fetchState) => fetchState.placeLocalizationFetchState.get(placeUuid));

export const notificationFetchStateSelector = createSelector(fetchStateSelector, (fetchState) => fetchState.notificationFetchState);

export const layoutsFetchStateByPlaceUuidSelector = (placeUuid: string) =>
  createSelector(fetchStateSelector, (fetchState) => fetchState.layoutFetchStates.get(placeUuid));

export const reservationFetchStateByPlaceUuidSelector = (placeUuid: string) =>
  createSelector(fetchStateSelector, (fetchState) => fetchState.reservationFetchState.get(placeUuid));

export const contactFetchStateByPlaceUuidSelector = (placeUuid: string) =>
  createSelector(fetchStateSelector, (fetchState) => fetchState.contactFetchState.get(placeUuid));

export const hoursFetchStateByPlaceUuidSelector = (placeUuid: string) =>
  createSelector(fetchStateSelector, (fetchState) => fetchState.hoursFetchState.get(placeUuid));

export const reservationSettingFetchStateByPlaceUuidSelector = (placeUuid: string) =>
  createSelector(fetchStateSelector, (fetchState) => fetchState.reservationSettingFetchState.get(placeUuid));

export const profileFetchStateByPlaceUuidSelector = (placeUuid: string) =>
  createSelector(fetchStateSelector, (fetchState) => fetchState.profileFetchState.get(placeUuid));

export const activatePlaceFetchStateSelector = createSelector(fetchStateSelector, (fetchState) => fetchState.activatePlaceFetchState);

export const placeLayoutsFetchStateSelector = (placeUuid: string) => createSelector(fetchStateSelector, (fetchState) => fetchState.placeLayouts.get(placeUuid));

export const placeFetchStateSelector = (placeUuid: string) => createSelector(fetchStateSelector, (fetchState) => fetchState.places.get(placeUuid));

export const placeFetchByTokenStateSelector = (token: string) => createSelector(fetchStateSelector, (fetchState) => fetchState.places.get(token));

export const loggedInUserFetchStateSelector = createSelector(fetchStateSelector, (fetchState) => fetchState.loggedInUserFetchState);

export const facebookPagesFetchStateSelector = (placeUuid: string) =>
  createSelector(fetchStateSelector, (fetchState) => fetchState.facebookPages.get(placeUuid));

export const facebookPageFetchStateSelector = (placeUuid: string) => createSelector(fetchStateSelector, (fetchState) => fetchState.facebookPage.get(placeUuid));

export const pricesFetchStateSelector = (feature: PremiumFeature, placeUuid: string) =>
  createSelector(fetchStateSelector, (fetchState) => fetchState.prices.get(getPriceKey(placeUuid, feature)));

export const subscriptionsFetchStateSelector = (feature: PremiumFeature, placeUuid: string) =>
  createSelector(fetchStateSelector, (fetchState) => fetchState.subscriptions.get(getSubscriptionKey(placeUuid, feature)));

export const countriesFetchStateSelector = createSelector(fetchStateSelector, (fetchState) => fetchState.countriesFetchState);

export const employeesFetchStateSelector = createSelector(fetchStateSelector, (fetchState) => fetchState.employeeFetchState);

export const tokenFetchStateSelector = (token: string) => createSelector(fetchStateSelector, (fetchState) => fetchState.tokenFetchStates.get(token));

export const companyGuestsFetchStateSelector = () => createSelector(fetchStateSelector, (fetchState) => fetchState.companyGuests);
